import { faChartBar, faHome, faSearch, faShip, faSignOut, faTemperatureHalf, faTruck } from '@fortawesome/pro-light-svg-icons';
import {
  faChartBar as faChartBarSolid,
  faCircle1,
  faCircle2,
  faCircle3,
  faCircle4,
  faCircle5,
  faHome as faHomeSolid,
  faSearch as faSearchSolid,
  faShip as faShipSolid,
  faTemperatureHalf as faTemperatureHalfSolid,
  faTruck as faTruckSolid
} from '@fortawesome/pro-solid-svg-icons';
import { navHmeUrl, navInfUrl, navOrdUrl, navOutUrl, navQuaUrl, navRfrUrl, navSectionHme, navSectionInf, navSectionOrd, navSectionOut, navSectionQua, navSectionRfr, navSectionSta, navStaUrl } from '../routing/routing.const';
import { textHome, textInfo, textOrders, textQuayjobs, textReeferHeating, textSignOut, textStats } from '../_config/i18n/i18n-interface';

import { SharedAccessKey } from './shared-access-key.const';
import { SpxNavigationItemI } from '@softpak/components/spx-navigation';

export const navItems: SpxNavigationItemI[] = [
  {
    hasTab: true,
    hasTile: false,
    code: navSectionHme,
    icon: faHome,
    iconShortcut: faHomeSolid,
    iconTab: faHomeSolid,
    routerLink: navHmeUrl,
    title: textHome,
  },
  {
    accessKey: SharedAccessKey.inf,
    hasTab: true,
    signInRequired: true,
    code: navSectionInf,
    accessKeyEither: [
      {
        accessKey: SharedAccessKey.inf,
      },
      {
        accessKey: SharedAccessKey.infCnt,
      },
      {
        accessKey: SharedAccessKey.infStk,
      },
    ],
    icon: faSearch,
    iconShortcut: faCircle1,
    iconTab: faSearchSolid,
    routerLink: navInfUrl,
    tileClasses: 'bg-linear-to-r from-yellow-400 to-yellow-600 hover:from-yellow-500 hover:to-yellow-700 focus:ring-yellow-400 text-black focus:ring-offset-white dark:focus:ring-offset-black',
    title: textInfo,
    currentSettingsRequired: true,
  },
  {
    accessKey: SharedAccessKey.ord,
    hasTab: true,
    signInRequired: true,
    code: navSectionOrd,
    icon: faTruck,
    iconShortcut: faCircle2,
    iconTab: faTruckSolid,
    routerLink: navOrdUrl,
    title: textOrders,
    tileClasses: 'bg-linear-to-r from-orange-400 to-orange-600 hover:from-orange-500 hover:to-orange-700 focus:ring-orange-400 text-black focus:ring-offset-white dark:focus:ring-offset-black',
    currentSettingsRequired: true,
  },
  {
    accessKey: SharedAccessKey.qua,
    hasTab: true,
    signInRequired: true,
    code: navSectionQua,
    accessKeyEither: [
      {
        accessKey: SharedAccessKey.qua,
      },
    ],
    icon: faShip,
    iconShortcut: faCircle3,
    iconTab: faShipSolid,
    routerLink: navQuaUrl,
    tileClasses: 'bg-linear-to-r from-red-400 to-red-600 hover:from-red-500 hover:to-red-700 focus:ring-red-400 text-black focus:ring-offset-white dark:focus:ring-offset-black',
    title: textQuayjobs,
    currentSettingsRequired: true,
  },
  {
    accessKey: SharedAccessKey.rfr,
    hasTab: true,
    signInRequired: true,
    code: navSectionRfr,
    accessKeyEither: [
      {
        accessKey: SharedAccessKey.rfr,
      },
      {
        accessKey: SharedAccessKey.rfrMon,
      },
      {
        accessKey: SharedAccessKey.rfrOrd,
      },
      {
        accessKey: SharedAccessKey.connectPlanning,
      },
      {
        accessKey: SharedAccessKey.rfrSet,
      },
    ],
    icon: faTemperatureHalf,
    iconShortcut: faCircle4,
    iconTab: faTemperatureHalfSolid,
    routerLink: navRfrUrl,
    tileClasses: 'bg-linear-to-r from-cyan-400 to-cyan-600 hover:from-cyan-500 hover:to-cyan-700 focus:ring-cyan-400 text-black focus:ring-offset-white dark:focus:ring-offset-black',
    title: textReeferHeating,
    currentSettingsRequired: true,
  },
  {
    signInRequired: true,
    code: navSectionSta,
    accessKeyEither: [
      {
        accessKey: SharedAccessKey.staAps,
      },
      {
        accessKey: SharedAccessKey.staEqs,
      },
      {
        accessKey: SharedAccessKey.staDsh,
      },
    ],
    icon: faChartBar,
    iconTab: faChartBarSolid,
    iconShortcut: faCircle5,
    routerLink: navStaUrl,
    tileClasses: 'bg-linear-to-r from-purple-400 to-purple-600 hover:from-purple-500 hover:to-purple-700 focus:ring-purple-400 text-black focus:ring-offset-white dark:focus:ring-offset-black',
    title: textStats,
    currentSettingsRequired: true,
    hasTab: true,
  },
  {
    signInRequired: true,
    code: navSectionOut,
    icon: faSignOut,
    routerLink: navOutUrl,
    tileClasses: 'bg-linear-to-r from-stone-400 to-stone-600 hover:from-stone-500 hover:to-stone-700 focus:ring-stone-400 text-black focus:ring-offset-white dark:focus:ring-offset-black',
    title: textSignOut,
  },
];
